import { CompanyPolicyModel } from "./companyPolicyModel";

export class AddCompanyPolicyModel extends CompanyPolicyModel{
    roleIds: string[];
}